// extracted by mini-css-extract-plugin
export default {"Slot":"TeamSlot_Slot__RrVLb"};